import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { List, Spacer } from 'theSource/components';
import { BenefitsPageResponseDto } from 'theSource/queries';
import {
  MEDICAL_BENEFIT_CATEGORY,
  DECLINED_COVERAGE_PLAN_LOOKUP_CODE,
} from 'theSource/utils';
import { getQuickLinkItems } from './utils';

export interface QuickLinksProps {
  data: BenefitsPageResponseDto;
}

export const QuickLinkList = ({ data }: QuickLinksProps) => {
  const { t } = useTranslation('pages.benefits');

  const medicalBenefitLookupCode = data?.data.current.find(
    (benefit) =>
      benefit.benefit_category === MEDICAL_BENEFIT_CATEGORY &&
      benefit.coverage.plan_lookup_code !== DECLINED_COVERAGE_PLAN_LOOKUP_CODE
  )?.benefit_lookup_code;
  const quickLinkItems = getQuickLinkItems(medicalBenefitLookupCode);

  return (
    <Box data-testid="quick-link-list">
      <h2 className="headline-3">{t('quickLinksTitle')}</h2>
      <Spacer height={4} />
      <List
        items={quickLinkItems}
        isCombined={false}
        spacing={2}
        isHomepage={true}
      />
    </Box>
  );
};
